<template>
  <div class="pc_user_left_hide_style">
    <div
      class="item_layout_style"
      :style="{ '--width': leftItem == 1 ? '4px' : '' }"
      @click="setItem(1)"
    >
      <div class="item_style">家庭配置药</div>
    </div>
    <div
      class="it_layout_style"
      :style="{ '--width': leftItem == 2 ? '4px' : '' }"
      @click="setItem(2)"
    >
      <div class="item_style">
        <div>我的家庭</div>
      </div>
    </div>
    <span class="add_people_tyle">+ 添加家庭成员</span>
    <div
      class="item_layout_style"
      :style="{ '--width': leftItem == 3 ? '4px' : '' }"
      @click="setItem(3)"
    >
      <div class="item_style">账单和物流</div>
    </div>
    <div
      class="item_layout_style"
      :style="{ '--width': leftItem == 4 ? '4px' : '' }"
      @click="setItem(4)"
    >
      <div class="item_style">收货地址</div>
    </div>
    <div
      class="item_layout_style"
      :style="{ '--width': leftItem == 5 ? '4px' : '' }"
      @click="setItem(5)"
    >
      <div class="item_style" @click="login_out_click">退出登录</div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  computed: {
    ...mapState(["cgmUserVO", "leftItem"]),
  },
  // props:['item'],
  data() {
    return {
      // item: 1,
    };
  },
  mounted() {
    // this.$emit("transfer", this.item);
  },
  methods: {
    ...mapMutations(["setCgmUserVO", "setLeftItem"]),
    setItem(v) {
      // this.item = v;
      // this.$emit("transfer", v);
      this.setLeftItem(v);
    },
    login_out_click() {
      this.setCgmUserVO(null);
      this.$router.push("/");
    },
  },
};
</script>
<style lang="scss" scoped>
@media (max-width: 768px) {
  .pc_user_left_hide_style {
    display: none;
  }
}
@media (min-width: 768px) {
  // .mobile_hide_style {
  //   display: none;
  // }
}
.pc_user_left_hide_style {
  // padding: 40px;
  background: #fff;
  border-radius: 11px;
  font-size: 18px;
  color: #202f3b;
  font-weight: bold;
  width: 24%;
}
.item_layout_style {
  margin: 40px 0;
  // border-left: 4px solid;
  cursor: pointer;
}
.add_people_tyle {
  padding-left: 30px;
  font-size: 15px;
  color: #8a8a8a;
}
.it_layout_style {
  // border-left: 4px solid;
  cursor: pointer;
}
.item_style {
  padding: 0 50px 0 30px;
  position: relative;
  height: 26px;
  line-height: 26px;
}
.item_style::before {
  position: absolute;
  content: "";
  width: var(--width);
  height: 26px;
  background: #202f3b;
  left: 0;
  top: 0;
  border-radius: 3px;
}

// .pc_user_left_hide_style > div {
//   margin-bottom: 26px;
// }
</style>